import React from 'react';
interface NumberInputProps {
  id: string;
  value: number | null;
  onChange: (v: number | null) => void;
  allowNull?: boolean;
  step?: number;
  placeholder?: string;
}
export function NumberInput({
  id,
  value,
  onChange,
  allowNull,
  step = 1,
  placeholder
}: NumberInputProps) {
  return <input id={id} type="number" inputMode="decimal" step={step} min={0} className="input" placeholder={placeholder ?? (allowNull ? 'No informado' : '0')} value={value === null ? '' : value} onChange={e => {
    const raw = e.target.value;
    if (raw === '') onChange(allowNull ? null : 0);else onChange(Math.max(0, Number(raw)));
  }} data-id="element-177" data-mp="3jzmavpzh2hl9" />;
}